import { getUser } from '@/api'
import store from '@/store'
import storage from '@/plugins/storage'

const getUserData = async token => {
  try {
    let response = await getUser(token)
    let user = response.data.data
    setUserData(user, token)
    return user
  } catch (error) {
    setUserData()
  }
}

export const setUserData = (user, token) => {
  store.dispatch('setUserAction', user || null)
  storage.set('access_token', token)
}

export const validateLogin = async () => {
  const accessToken = storage.get('access_token')
  return accessToken ? (await getUserData(accessToken)) : setUserData()
}

export const getDefaultPage = user => {
  return {
    'admin': 'index'
  }[(user || {}).role] || (user ? 'index' : 'main')
}

export const rolePermission = roles => {
  let user = store.user.user || { role: 'guest' }
  return roles.includes(user.role)
}
